import { render, staticRenderFns } from "./summary_table.vue?vue&type=template&id=3960db36&scoped=true&"
import script from "./summary_table.vue?vue&type=script&lang=js&"
export * from "./summary_table.vue?vue&type=script&lang=js&"
import style0 from "./summary_table.vue?vue&type=style&index=0&id=3960db36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960db36",
  null
  
)

export default component.exports